import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";

import { SimpleEmployee } from "../../../../../../dtos/employee";
import { AjaxResult } from "../../../../../../enums/ajaxResult";
import { useApi } from "../../../../../useApi";

import { useEffectiveOrgId } from "./useEffectiveOrgId";

export function useEmployees(
    boxOrgId: number | undefined,
    boxSiteId: number | undefined,
    enabled: boolean,
): {
    employees: SimpleEmployee[];
    load: () => void;
    loading: boolean;
} {
    const { enqueueSnackbar } = useSnackbar();
    const { employeeApi } = useApi();
    const [employees, setEmployees] = useState<SimpleEmployee[]>([]);
    const [loading, setLoading] = useState(false);
    const orgId = useEffectiveOrgId(boxOrgId)

    const load = useCallback(() => {
        if (!enabled || !boxSiteId) return;
        setEmployees([]);
        setLoading(true);
        employeeApi.getSiteSimpleEmployees(orgId, boxSiteId).then((r) => {
            if (r.result === AjaxResult.Success && r.data) {
                setEmployees(r.data);
            } else {
                enqueueSnackbar(
                    "Failed to get list of employees for organization",
                    { variant: "error" },
                );
            }
            setLoading(false);
        });
    }, [boxSiteId, orgId, employeeApi, enqueueSnackbar, enabled]);

    useEffect(() => {
        load();
    }, [load]);

    return {
        employees,
        load,
        loading,
    };
}
